import Button from '@components/designSystem/Button'
import { Headline } from '@components/designSystem/Headline'
import { useCurrentStoreId } from '@hooks/useCurrentStore'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

function ScanDoesNotExist() {
  const { t } = useTypedTranslation()
  const storeId = useCurrentStoreId()

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <Headline i18nKey="scanSelection.scanDoesNotExist.title" />
      <span className="text-center text-lg text-gray-500">
        {t('scanSelection.scanDoesNotExist.subtitle')}
      </span>
      <Button href={routesFactory.home(storeId)}>
        {t('scanSelection.scanDoesNotExist.back')}
      </Button>
    </div>
  )
}

export default ScanDoesNotExist
